exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\nul.pagination li a {\r\n    cursor: pointer;\r\n    display: block;\r\n}\r\n\r\n.pageSize label {\r\n    padding: 0 5px;\r\n}\r\n\r\n.table-center th, \r\n.table-center td {\r\n    text-align: center;\r\n}\r\n.table-left th, \r\n.table-left td {\r\n    text-align: left;\r\n}\r\n.table-right th, \r\n.table-right td {\r\n    text-align: right;\r\n}\r\n", ""]);

// exports
